import React from "react";

import UnsupportedBrowserWarning from "./UnsupportedBrowserWarning/UnsupportedBrowserWarning";
import AppStateProvider from "./state";

import { VideoApp } from "./App";
type Props = {
  coachingId: string;
  user: {
    id: string;
    displayName: string;
    profileImageUrl: string;
    askRecordingConsent: boolean;
    showFirstVideoCallInfo: boolean;
  };
};

export const VideoCall: React.FC<Props> = ({ coachingId, user }: Props) => (
  <UnsupportedBrowserWarning>
    <AppStateProvider user={user}>
      <VideoApp coachingId={coachingId} />
    </AppStateProvider>
  </UnsupportedBrowserWarning>
);
